<template>
    <span>
        <v-progress-circular v-if="spinner" indeterminate color="primaryText" :width="2" :size="14" class="mr-1" />
        <span v-if="prepend">{{ prepend }}</span>
        <span :style="{ display: 'inline-flex', width: frameWidth }">{{ text }}</span>
        <span v-if="append">{{ append }}</span>
    </span>
</template>

<script>
export default {
    name: 'TextAnimationLoader',
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        spinner: {
            type: Boolean,
            default: false
        },
        frames: {
            type: Array,
            default: () => ['', '.', '..', '...']
        },
        frameWidth: {
            type: String,
            default: '1rem'
        },
        delay: {
            type: Number,
            default: 300
        },
        prepend: {
            type: String,
            default: null
        },
        append: {
            type: String,
            default: null
        }
    },
    data: () => ({
        index: 0,
        timer: null
    }),
    computed: {
        text() {
            return this.frames[this.index];
        }
    },
    watch: {
        loading: {
            immediate: true,
            handler(loading) {
                loading ? this.startAnimation() : this.stopAnimation();
            }
        }
    },
    methods: {
        startAnimation() {
            this.timer = setInterval(() => {
                this.index = (this.index + 1) % this.frames.length;
            }, this.delay);
        },
        stopAnimation() {
            clearInterval(this.timer);
        }
    }
};
</script>
